import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faCopy, faFileAlt } from '@fortawesome/pro-solid-svg-icons';

export default function SaveDocumentTemplateModal({ saving, show, templateName, onClose, onSave }) {
  const [propagateToChildren, setPropagateToChildren] = React.useState(false);

  React.useEffect(() => {
    if (show) setPropagateToChildren(false);
  }, [show]);

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        Page Default Changes
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          These page changes can be saved to just this template or to all child templates created from it.
        </div>
        <strong className="fw-semibold">
          Where would you like to save these changes?
        </strong>
        <div className="row">
          <label className="radio radio-inline col-5 border px-5 py-4 m-4">
            <input
              checked={!propagateToChildren}
              name="save-scope"
              type="radio"
              onChange={() => setPropagateToChildren(false)}
            />
            <FontAwesomeIcon className="mx-2" icon={faFileAlt} size="lg"/>
            {templateName}
          </label>
          <label className="radio radio-inline col-5 border px-5 py-4 m-4">
            <input
              checked={propagateToChildren}
              name="save-scope"
              type="radio"
              onChange={() => setPropagateToChildren(true)}
            />
            <FontAwesomeIcon className="mx-2" icon={faCopy} size="lg"/>
            All Child Templates
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={saving} label="Cancel" variant="ghost" onClick={onClose} />
        <Button
          disabled={saving}
          label={saving ? 'Saving ...' : 'Save Changes'}
          onClick={() => onSave(propagateToChildren)}
        />
      </Modal.Footer>
    </Modal>
  );
}

SaveDocumentTemplateModal.propTypes = {
  saving: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  templateName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
